/* src/app/shared/components/main-menu/main-menu.component.scss */
.header {
  line-height: var(--header-height);
}
.header .main-container {
  display: flex;
  justify-content: space-between;
}
.header .main-container .logo {
  height: var(--header-height);
  display: flex;
  align-items: center;
}
.header .main-container .logo-img {
  display: block;
  height: 2.625rem;
  width: 21.875rem;
  background-repeat: no-repeat;
  background-size: 100%;
  background-image: url(https://content.workpartners.com/vaccine/logos/UPMC_VACCINE\ PORTAL.jpg);
  background-position: 0 -13%;
}
@media screen and (max-width: 700px) {
  .header .main-container .logo-img {
    height: 2.063rem;
    width: 17.5rem;
  }
}
.header .main-container ods-button {
  --ods-color-purple-50: var(--neutral-60);
  --font-weight-normal: var(--font-weight-book);
}
.header .main-container ods-button::part(button) {
  background: transparent;
  border: 0;
  padding: 0;
  color: inherit;
  font: inherit;
  text-decoration: none;
  text-align: left;
  gap: 0;
}
.header .main-container ods-button::part(label) {
  color: inherit;
}
.header .main-container .main-menu__link::part(label) {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}
.header .main-container .main-menu__link {
  display: inline-block;
  font-size: 1.2rem;
  cursor: pointer;
  margin-right: 2.5rem;
  height: var(--header-height);
}
.header .main-container .main-menu__link.active_home i {
  display: none;
}
.header .main-container .main-menu__link.active {
  margin-bottom: -0.063rem;
  border-bottom: 0.3rem solid var(--brand-50-hover);
}
.header .main-container .main-menu__link:last-child {
  margin-right: 0;
}
.header .main-container .main-menu__link-title {
  margin-left: 0.313rem;
}
@media screen and (max-width: 600px) {
  .header .main-container .main-menu__link:first-child {
    margin-right: 0.625rem;
  }
}
:host ::ng-deep a {
  text-decoration: none !important;
}
h1 {
  margin: 0;
}
/*# sourceMappingURL=main-menu.component.css.map */
